import {
  storeAuthorizedDSPsAction,
  storeAuthorizedEntitiesAction,
  storeAuthorizedLpsAction,
  storeAuthorizedLpSelectedAction,
} from '../../actions/lps/actions';

export const authorizationDispatch = (clwsDispatch) => ({
  dispatchGetAuthorizedEntities: (payload) =>
    clwsDispatch(storeAuthorizedEntitiesAction(payload)),
  dispatchGetAuthorizedLps: (payload) =>
    clwsDispatch(storeAuthorizedLpsAction(payload)),
  dispatchGetAuthorizedDSPs: (payload) =>
    clwsDispatch(storeAuthorizedDSPsAction(payload)),
  dispatchGetLPDetails: (payload) =>
    clwsDispatch(storeAuthorizedLpSelectedAction(payload)),
});

export default authorizationDispatch;
